/*
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2021-01-15 09:48:04
 */

import { projectPersonnelManagement } from '@/api/ajax';
/**
 * @description: 获取是否为过去任务
 * @param {string} taskDt
 * @return {boolean} true是
 */
export const isHistoryTask = taskDt => {
  let time = new Date();
  return (
    +new Date(taskDt) <
    +new Date(`${time.getFullYear()}-${time.getMonth() + 1}`)
  );
};

/**
 *
 * @param {*} file 需要检查的excel文件
 * @param {*} projectId 项目ID
 * @param {*} checkType  2 批量导入 1 预采购量导入
 * @param {*} callback  检查通过后执行的函数
 */
export const checkProjectTaskPlanExcel = async function(
  file,
  projectId,
  checkType,
  callback
) {
  try {
    if (!this.$checkNeedUserTag(this.$store.state.homeProject)) {
      console.warn(
        '不符合显示人员标签功能的条件，所以checkProjectTaskPlanExcel不校验excel文件'
      );
      callback && callback();
      return;
    }
    if (!file) {
      callback && callback();
      return;
    }
    const h = this.$createElement;
    // 检查文件中人员标签是否为空
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);
    formData.append('checkType', checkType);
    this.SET_BTLOADING && this.SET_BTLOADING(true);
    const {
      data: {
        data: { total, nullTotal }
      }
    } = await projectPersonnelManagement.checkProjectTaskPlanExcel(formData);
    if (nullTotal > 0) {
      let isCheck = false;
      this.$xrkDialog({
        ...{
          title: '',
          width: '450px',
          success: params => {
            if (params.confirm) {
              this.$xrkDialog.remove();
              if (isCheck) {
                projectPersonnelManagement.updateSkip({
                  projectId: projectId,
                  [checkType == 1
                    ? 'isPeopleTaskSkip'
                    : 'isProjectPeopleSkip']: 1
                });
              }
              callback && callback();
            }
          }
        },
        $slots: {
          default: h('div', { style: 'text-align:center;' }, [
            h(
              'div',
              { style: 'margin: 10px 0 30px 0;font-size: 16px;' },
              `您上传的人员名单为${total}人, ${nullTotal}人未设置人员标签,是否继续?`
            ),
            h(
              'el-checkbox',
              {
                on: {
                  change: v => {
                    isCheck = v;
                  }
                }
              },
              '本项目不再提示'
            )
          ])
        }
      });
    } else {
      callback && callback();
    }
    this.SET_BTLOADING && this.SET_BTLOADING(false);
  } catch (error) {
    console.error(error);
    callback && callback();
    this.SET_BTLOADING && this.SET_BTLOADING(false);
  }
};
